const Mine = () => import(/* webpackPrefetch: true, webpackChunkName: 'myMatches' */ 'wap/views/myMatches/components/myMatchesAll.vue')
const Fixtures = () => import(/* webpackPrefetch: true, webpackChunkName: 'myMatches' */ 'wap/views/myMatches/components/fixtures.vue')
const MyMatches = () => import(/* webpackPrefetch: true, webpackChunkName: 'myMatches' */ 'wap/views/myMatches/App.vue')

const routes = [
  {
    path: '/my_matches',
    component: MyMatches,
    children: [
      {
        path: '',
        name: 'my_matches',
        component: Mine,
        meta: {
          title: 'My Matches | MSport',
          enableTheme: true,
          hideHeader: true
        }
      }
    ]
  },
  {
    path: '/fixtures',
    component: MyMatches,
    meta: {
      hideHeader: true
    },
    children: [
      {
        path: '',
        name: 'fixtures',
        component: Fixtures,
        props: (route) => ({ sportId: decodeURIComponent(route.query.tab) }),
        meta: {
          enableTheme: true,
          hideHeader: true
        }
      }
    ]
  }
]

export default routes
